import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    textAlign: 'center',
    height: '135px',
    backgroundColor: '#121927',
    padding: '20px 0',
    [theme.breakpoints.down('md')]: {
      height: '54px',
      padding: '5px 0',
    },
  },
  scoreContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    color: '#ffffff',
  },
  versusContainer: {
    padding: '20px',
    '& > img': {
      width: 'auto',
      height: '100%',
    },
    [theme.breakpoints.down('md')]: {
      padding: '5px',
    },
  },
  teamLogo: {
    width: 'auto',
    height: '100%',
  },
  teamScore: {
    color: '#ffffff',
    fontSize: '55px',
    fontWeight: 'bold',
    [theme.breakpoints.down('md')]: {
      fontSize: '27px',
    },
  },
}));

export default useStyles;
